import useSWR from "swr";

import { simpleFetcher } from "../fetcher";

const url = "/api/v2/sso/config";

export interface SsoConfig {
  ssoEnabled: boolean;
  ssoOnly: boolean;
}

export function useSsoConfig() {
  return useSWR<SsoConfig, Error>(url, simpleFetcher);
}
